import { AudiencePage } from "@/components/sections/AudiencePage";
import { VERTICALS } from "@/lib/content";
import SEO from "@/components/common/SEO";

const points = [
  {
    icon: "FileText",
    title: "Tell your story well",
    body: "Resumes, cover letters and profiles that pass the ATS and land with the humans who matter.",
  },
  {
    icon: "Compass",
    title: "Move with strategy",
    body: "Career consultation and job-search strategy so your next move is deliberate, not reactive.",
  },
  {
    icon: "MessagesSquare",
    title: "Show up with confidence",
    body: "Interview preparation and professional branding that help you present the best, real version of you.",
  },
];

export default function ForCandidates() {
  const verticals = VERTICALS.filter((v) => v.id === "career");

  return (
    <>
      <SEO
        title="Career Services, Resume & ATS Support | Success Crest Consulting"
        description="Success Crest Consulting provides career consultation, resume building, ATS review, LinkedIn optimisation, interview preparation, professional branding, and job search strategy."
        path="/for-candidates"
      />

      <AudiencePage
        testId="for-candidates-page"
        overline="For Candidates"
        title="Make your next career move deliberate."
        subtitle="For professionals who want their positioning, presence and search strategy to work as hard as they do, SCC's Career Solutions meet you where you are."
        points={points}
        verticals={verticals}
        ctaPath="candidates"
        ctaLabel="Tell Us What You Need"
      />
    </>
  );
}
